// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NAVE","comment":"styles_comment__10C6w"};